/*
 * @Date: 2020-04-14 11:42:24
 * @LastEditors: yuanjianlong@aixuexi.com
 * @LastEditTime: 2020-04-14 14:48:28
 * @FilePath: \st-teacher-2020\src\directive\index.ts
 */
import utils from '@/utils';

export default (Vue: any) => {
  // 点击事件埋点指令：在dom上添加a-a-t、data-aad属性
  // 使用方法：v-click-log="{pathName: 'xxx', routeName: 'xxx', btnId='xxx'}"
  Vue.directive('click-log', {
    inserted(el: any, binding: any) {
      const { value } = binding;
      if (value) {
        const { pathName, routeName, btnId } = value;
        const aad = utils.getAad(pathName, routeName, btnId);
        el.setAttribute('a-a-t', '');
        el.setAttribute('data-aad', aad);
      }
    },
  });
};
